import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-auction",
  "use": "icon-auction-usage",
  "viewBox": "0 0 57.2 57.2",
  "content": "<symbol viewBox=\"0 0 57.2 57.2\" id=\"icon-auction\">\r\n<path d=\"M2.6,31.9l16.9,9.5c1.5,0.9,3.5,0.2,4.2-1.2l0.2-0.5c0.4-0.7,0.5-1.5,0.2-2.4c-0.2-0.7-0.7-1.5-1.5-1.9\r\n\tl-12.2-6.9l-4.7-2.6c-0.5-0.2-1-0.4-1.5-0.4c-1.1,0-2.1,0.6-2.7,1.6l-0.2,0.5C1,28.4,0.9,29.2,1.1,30C1.4,30.9,1.9,31.5,2.6,31.9z\" />\r\n<path d=\"M16.8,6.4l16.9,9.5c1.5,0.9,3.5,0.2,4.2-1.2l0.2-0.5c0.4-0.7,0.5-1.5,0.2-2.4c-0.2-0.7-0.7-1.5-1.5-1.9\r\n\tL20.2,0.4c-0.5-0.2-1-0.4-1.5-0.4c-1.1,0-2.1,0.6-2.7,1.6l-0.2,0.5c-0.4,0.7-0.5,1.5-0.2,2.4C15.6,5.2,16.2,5.9,16.8,6.4z\" />\r\n<rect x=\"11.2\" y=\"12.6\" transform=\"matrix(0.4868 -0.8735 0.8735 0.4868 -7.925 28.0074)\" class=\"st0\" width=\"17.4\" height=\"16.3\" />\r\n<path d=\"M55.8,38L30.4,23.8l-2.5,4.4l25.4,14.1c0.4,0.2,0.7,0.4,1.2,0.4c0.9,0,1.7-0.5,2.2-1.2\r\n\tC57.5,40.1,57,38.6,55.8,38z\" />\r\n<path d=\"M49.7,50.5H5.9C4.2,50.5,3,52,3,53.8c0,1.7,1.2,3.4,2.9,3.4h43.7c1.6,0,2.9-1.5,2.9-3.4S51.4,50.5,49.7,50.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/auction.svg
// module id = ./app/general/svg/auction.svg
// module chunks = app